/*
 ClioWidgetForm light version
 Build 1639480452
 Selectors:
   form: .clio-form-widget-light
   tag: [name='clio_tag']
   email: [name='clio_email']
   consent: [name='clio_consent']
   result: .clio-form-result
*/

document.addEventListener('DOMContentLoaded', () => {
  function getOptions(form) {
    return {
      'result': {
        'validation': getLabels(form, 'data-validation', `<span class="entypo-emoji-neutral"></span> Ricontrolla la tua email! Sembra esserci un errore.`),
        'validation_privacy': getLabels(form, 'data-validation-privacy', `<span class="entypo-emoji-neutral"></span> Il tuo consenso al trattamento dei dati e alla ricezione di comunicazioni Ã¨ obbligatorio per proseguire!`),
        'loading': getLabels(form, 'data-loading', `<span class="entypo-hour-glass"></span> Solo qualche secondo stiamo salvando la tua richiesta...`),
        'error': getLabels(form, 'data-error', `<span class="entypo-emoji-sad"></span> Ci dispiace ma qualcosa Ã¨ andato storto nel salvataggio dei tuoi dati! Ti preghiamo di inviarci una mail a shop@cliomakeup.com`),
        'success': getLabels(form, 'data-success', `<span class="entypo-emoji-happy"></span> Grazie! Ti confermiamo l'iscrizione alla newsletter di ClioMakeUp Shop!`),
      },
      'serverless': true,
      'endpoint': {
        'server': `https://landing.cliomakeup.com/app/submit/`,
        'aws': `https://500ekj90bb.execute-api.eu-west-1.amazonaws.com/Prod/submitForm`,
      }
    }
  }
  const validations = {
    required: function(el){
      if(el.type == "radio" || el.type == "checkbox") {
        return el.checked
      } else {
        return el.value !== '';
      }
    },
    checked: function(el) { return el.checked },
    notchecked: function(el) { return !el.checked },
    day: function(el) { return el.value.match(/^([1-9]|0[1-9]|1[0-9]|2[0-9]|3[01])$/); },
    month: function(el) { return el.value.match(/^([1-9]|0[1-9]|1[012])$/); },
    year: function(el) { return el.value.match(/^(19[0-9][0-9]|20[012][0-9])$/); },
    phone: function(el) { return el.value.match(/^[0-9]{6,15}$/); },
    email: function(el) { return el.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);}
  }
  function getLabels(form, attr, placeholder) {
    const label = form.getAttribute(attr)
    return label ? label : placeholder
  }
  function handleErrors(response) {
    if (!response.ok) { throw Error(response.statusText); }
    return response.json();
  }
  function printResult(form, data, options, result) {
    form.classList.remove('loading');
    form.classList.add('success');
    let message = '';
    const eventName = form.hasAttribute('data-event') ? form.getAttribute('data-event') : 'widgetform_send';
    const event = new Event(eventName);
    if('mailchimp' in data && data.mailchimp == 200) {
      message = options.result.success;
      document.dispatchEvent(event);
    } else if('serverless' in data && data.serverless && data.status) {
      message = options.result.success;
      document.dispatchEvent(event);
    } else {
      form.classList.remove('success');
      form.classList.add('failed');
      message = options.result.error
    }
    result.innerHTML = message.replace('$name', 'fname' in data ? data.fname : '').replace('$ticket', 'zendesk' in data ? data.zendesk : '')
  }
  function buildForm(form, options){
    let inputs = form.querySelectorAll('input');
    let result = form.querySelector('.clio-form-result');
    form.addEventListener("submit", function(e) {
      e.preventDefault()
      let error = false
      Array.prototype.forEach.call(inputs, function(input, i){
        let attr = input.name == 'clio_email' ? 'required email' : input.name == 'clio_consent' ? 'required' : ''
        let rules = attr ? attr.split(' ') : ''
        if(!rules.includes('required') && !input.value) {
          //skip validation
        } else {
          Array.prototype.forEach.call(rules, function(rule, i){
            if(!error) {
              if(!validations[rule](input)) {
                error = input.name
              }
            }
          })
        }
      })
      if(error) {
        result.innerHTML = error == 'clio_marketing' || error == 'clio_consent' ? options.result.validation_privacy : options.result.validation
        return false
      }
      if((!form.classList.contains('loading'))&&(!form.classList.contains('success'))) {
        form.classList.add('loading');
        form.classList.remove('success', 'failed');
        result.innerHTML = options.result.loading;
        let submiturl = options.serverless ? options.endpoint.aws : options.endpoint.server;
        let headers = {
          'Accept': 'application/json; charset=utf-8',
          'Content-type': 'application/json; charset=UTF-8'
        }
        let tokenRequest = { token: 6 };
        //build data object
        let finalRequest = Object.fromEntries(new FormData(form))
        if('clio_preferences' in finalRequest) {
          let checkboxes = wrap.querySelectorAll('input[name="clio_preferences"]');
          let checked = []
          Array.prototype.forEach.call(checkboxes, function(checkbox, i){ if(checkbox.checked) { checked.push(checkbox.value) } })
          finalRequest.clio_preferences = checked
        }
        if('clio_tag' in finalRequest) {
          finalRequest.tag = finalRequest.clio_tag
        }
        finalRequest.ticket = false
        fetch(submiturl, {
          method: 'POST',
          body: JSON.stringify(options.serverless ? finalRequest : tokenRequest),
          headers: headers
        }).then(handleErrors).then(function(data) {
          if('token' in data) {
            finalRequest.token = data.token
            fetch(submiturl, {
              method: 'POST',
              body: JSON.stringify(finalRequest),
              headers: headers
            }).then(handleErrors).then(function(data) {
              printResult(form, data, options, result)
            }).catch(function(error) {
              printResult(form, { error: error }, options, result)
            });
          } else {
            printResult(form, data, options, result)
          }
        }).catch(function(error) {
          printResult(form, { error: error }, options, result)
        });
      }
    });
  }
  const forms = document.querySelectorAll('.clio-form-widget-light')
  forms.forEach((form) => { buildForm(form, getOptions(form)) })
  document.addEventListener('ClioLoadLightWidget', (e) => {
    buildForm(e.detail, getOptions(e.detail))
  })
})